//引入nprogress 进度条插件

import router from '@/router/index'
import NProgress from 'nprogress'
// 引入进度条样式
import 'nprogress/nprogress.css'
import {getDataInLocalStorage, removeDataInLocalStorage} from '@/utils/localStorageUtils'
// 简单配置  进度条
NProgress.inc(0.2)
NProgress.configure({
  easing: 'ease',
  speed: 500,
  showSpinner: false
})

router.beforeEach((to, from, next) => {
  NProgress.start()
//判断是否从邮件过来或者是否通过用户管理系统过来
  const isFormLink=window.location.search.includes('user')||window.location.search.includes('withCode')
  if(isFormLink&&to.path==='/login'){
    if(to.path==='//login'){
      const newTo = { ...to, path: '/login' }; // 创建一个新的导航对象
      removeDataInLocalStorage('token')
      next(newTo); // 导航到新的目标路径
    }else {
      next()
    }
  }else {
    // 获取令牌判断用户是否登陆
    const hasToken = getDataInLocalStorage('token')
    // 有令牌 表示已经登陆
    if (to.path == '/login') {
      if (hasToken) {
        next('/sampleUpload')
      }
      next()
    } else if(to.path == '/') {
      var role = getDataInLocalStorage('role')
      if(!role || !hasToken) {
        next('/login')
      }  else if(role === 'project') {
        next('/projectHome')
      } else {
        next('/userHome')
      }
    } else {
      if (hasToken) {
        next()
      } else {
        next('/login')
      }
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})
